import styled from '@mui/material/styles/styled'
import Typography from '@mui/material/Typography'

export const Text = styled(Typography, {
  name: 'Text',
  slot: 'Root',
})(({ theme }) => ({
  marginBottom: theme.spacing(2),
}))
